export default function TopBar({ user, onMenu, onLogout }) {
  return (
    <header className="topbar">
      <button type="button" className="topbar__menu" onClick={onMenu} aria-label="메뉴 열기">
        <span />
        <span />
        <span />
      </button>
      <div className="topbar__title">
        <strong>ENSIGHT</strong>
        <span>재고관리시스템</span>
      </div>
      <div className="topbar__user">
        <div className="topbar__user-text">
          <strong>{user?.name || '사용자'}</strong>
          <span>
            {user?.department} · {user?.username}
          </span>
        </div>
        <button type="button" className="btn btn--ghost btn--small" onClick={onLogout}>
          로그아웃
        </button>
      </div>
    </header>
  )
}
